export const width = 369;
export const height = 340;
export default __webpack_public_path__ + "static/4.cb6966f0.svg";